import { getCookie } from 'cookies-next/client';

import { COOKIES } from '@/shared/constants/cookies';

const cookieTemporaryDisableCookies = getCookie(
  COOKIES.TEMPORARY_DISABLE_COOKIES
);
export const userAllowsMarketingCookies =
  cookieTemporaryDisableCookies === 'false';
